import YatungButton from '@Src/_basic/components/YatungButton';
import YatungTable, { Column } from '@Src/_basic/components/YatungTable';
import { getJwtExpiredTime } from '@Src/_basic/helpers/JwtHelpers';
import { Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  token: string;
  loading: boolean;
  onRegenerate: () => void;
}

type KeyRow = {
  token: string;
  expiredTime: string;
};

export default function ThirdPartyKeyManagementTable({ token, loading, onRegenerate }: Props) {
  const { t: i18T } = useTranslation();

  const data: Array<KeyRow> = useMemo(() => (token ? [{ token, expiredTime: getJwtExpiredTime(token) }] : []), [token]);

  const columns: Array<Column> = [
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.KEY'),
      dataField: 'token',
      width: '65%',
      formatter: ({ cellContent }) => (
        <Typography sx={{ fontSize: 16, wordBreak: 'break-all' }}>{cellContent}</Typography>
      ),
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.KEY_EXPIRED_TIME'),
      dataField: 'expiredTime',
      width: '20%',
    },
    {
      text: i18T('GLOBAL.ACTION'),
      dataField: 'action',
      formatter: () => (
        <YatungButton
          text={i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.REGENERATE_KEY')}
          variant={'contained'}
          type={'button'}
          size={'large'}
          color={'blue'}
          disabled={loading}
          onClick={onRegenerate}
        />
      ),
    },
  ];

  return (
    <>
      <Stack direction={'row'} justifyContent={'space-between'} sx={{ my: 1 }}>
        <Typography sx={{ color: '#6C708C', fontSize: 28 }}>
          {i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.KEY_MANAGEMENT')}
        </Typography>
      </Stack>
      <YatungTable columns={columns} data={data} loading={loading} sx={{ minHeight: 'auto' }} />
    </>
  );
}
